// Mock data for Tamircim26 website

export const businessInfo = {
  name: "Tamircim26",
  tagline: "Küçük Ev Aletleri Tamir Uzmanı",
  description: "Eskişehir'in güvenilir küçük ev aletleri tamir servisi. 10 yılı aşkın deneyimimizle tüm marka ve modellerde profesyonel tamir hizmeti sunuyoruz.",
  phone: "0530 484 07 43",
  address: "Osmangazi, Basın Şehitleri Cd. no221/b, 26150 Odunpazarı/Eskişehir",
  workingHours: "Pazartesi - Cumartesi: 09:00 - 19:00",
  email: "info@tamircim26.com"
};

export const services = [
  {
    id: 1,
    title: "Elektrikli Süpürge",
    description: "Tüm marka elektrikli süpürgelerin motor, hortum ve aksesuar tamiri",
    icon: "vacuum"
  },
  {
    id: 2,
    title: "Ütü Tamiri",
    description: "Buharlı ütü, kuru ütü ve ütü istasyonu tamiri",
    icon: "iron"
  },
  {
    id: 3,
    title: "Blender & Mikser",
    description: "El blenderi, mutfak robotu ve mikser tamiri",
    icon: "blender"
  },
  {
    id: 4,
    title: "Tost Makinesi",
    description: "Tost makinesi, waffle makinesi ve sandviç yapıcı tamiri",
    icon: "sandwich"
  },
  {
    id: 5,
    title: "Çay & Kahve Makinesi",
    description: "Çay makinesi, kahve makinesi ve su ısıtıcı tamiri",
    icon: "coffee"
  },
  {
    id: 6,
    title: "Saç Kurutma & Şekillendirici",
    description: "Saç kurutma makinesi, düzleştirici ve maşa tamiri",
    icon: "hairdryer"
  }
];

export const features = [
  {
    id: 1,
    title: "Hızlı Servis",
    description: "Çoğu tamir aynı gün içinde tamamlanır"
  },
  {
    id: 2,
    title: "Uygun Fiyat",
    description: "Rekabetçi fiyatlarla kaliteli hizmet"
  },
  {
    id: 3,
    title: "Garanti",
    description: "Tüm tamirlerimiz 6 ay garantilidir"
  },
  {
    id: 4,
    title: "Uzman Kadro",
    description: "10+ yıllık deneyimli teknisyenler"
  }
];

export const navLinks = [
  { id: 1, label: "Ana Sayfa", href: "#home" },
  { id: 2, label: "Hizmetler", href: "#services" },
  { id: 3, label: "Hakkımızda", href: "#about" },
  { id: 4, label: "İletişim", href: "#contact" }
];
